import { Component } from '@angular/core';

@Component({
  selector: 'mprd-disney-plus-modal',
  templateUrl: './disney-plus-modal.component.html',
})
export class DisneyPlusModalComponent {
  public destroy: Function;

  constructor() {}

  close() {
    this.destroy();
  }
}
